import React, { ReactNode, useEffect, useState } from "react";
import Overlay from "user/components/common/Overlay";

export type OverlayProps = {
    open: boolean;
    content: ReactNode | null;
};

export default function useOverlay() {
    const [overlay, setOverlay] = useState<OverlayProps>({
        open: false,
        content: null,
    });

    const openOverlay = (content: ReactNode) => {
        setOverlay({ open: true, content });
    };

    const closeOverlay = () => {
        setOverlay({ open: false, content: null });
    };

    return {
        overlay,
        setOverlay,
        openOverlay,
        closeOverlay,
    };
}

export function OverlayWrapper({
    children,
    overlay,
    closeOverlay,
}: {
    children: ReactNode;
    overlay: OverlayProps;
    closeOverlay: () => void;
}) {
    // 브라우저 뒤로가기 버튼 클릭시 오버레이 닫기
    useEffect(() => {
        const preventGoBack = () => {
            if (overlay.open) {
                closeOverlay();
                window.history.go(1);
            }
            // window.history.pushState(null, "", window.location.pathname);
        };
        window.addEventListener("popstate", preventGoBack);
        return () => window.removeEventListener("popstate", preventGoBack);
    }, [overlay.open]);

    return (
        <React.Fragment>
            {children}
            <Overlay overlay={overlay} />
        </React.Fragment>
    );
}
